import React from 'react'
import moment from 'moment'
import { Row, Col } from 'antd'
import { Text } from 'src/components/Ant'
import { R14Header } from 'src/store/ducks/reports/types'
import * as Css from './styles'

interface SectionHeaderProps
  extends Readonly<{
    data: R14Header[]
  }> {}

function SectionHeader({ data }: SectionHeaderProps) {
  const { ended_on, started_on } = data?.[0] || {}

  const startDate = `${
    moment(moment.unix(started_on).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`
  const endDate = `${
    moment(moment.unix(ended_on).utc().format('YYYYMMDD')).format(
      'DD/MM/YYYY'
    ) || '-'
  }`

  return (
    <Css.SectionHeader>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.12.header.start_date">
            <span id="value">{startDate}</span>
          </Text>
        </Col>
      </Row>
      <Row>
        <Col span={16}>
          <Text colon id="header" title="web.report.12.header.end_date">
            <span id="value">{endDate}</span>
          </Text>
        </Col>
      </Row>
    </Css.SectionHeader>
  )
}

export default SectionHeader
